<template>
  <div>
    <b-modal
      id="modal-logout"
      centered
      title="Confirm Exit"
      ok
      ok-variant="success"
      @cancel="hide2nd()"
      cancel-variant="danger"
      @ok="loggingOut()"
    >
      <template v-slot:modal-ok> Yes, Logout </template>
      <p>Are You sure you want to Logout?</p>
    </b-modal>
    <div :class="navbody" class="dashbody p-5 pl-3">
      <b-link :to="{ name: 'dashhome' }">
        <img src="@/assets/logo.png" class="dash-logo" />
      </b-link>

      <b-link
        class="dashlink mt-5"
        :class="activeDashRoute"
        active-class="mactive"
        :to="{ name: 'dashhome' }"
      >
          <b-icon-grid
          class="mr-3 mt-1"
          font-scale="1.5"
        ></b-icon-grid>
        <span class="mt-1">Dashboard</span>
      </b-link>
      <b-link
        class="dashlink"
        v-if="details.clearance_level > 0"
        :to="{ name: 'adminhome' }"
      >
        <!-- <img src="@/assets/profile.png" class="mr-3 icon-img"> -->
        <b-icon-person-check
          class="mr-3"
          font-scale="1.5"
        ></b-icon-person-check>
        <span class="mt-1">Admin Page</span>
      </b-link>
      <b-link
        class="dashlink"
        :class="activeRoute"
        active-class="active"
        :to="{ name: 'moreresults' }"
      >
          <b-icon-file-earmark-text
          class="mr-3 mt-1"
          font-scale="1.5"
        ></b-icon-file-earmark-text>
        <span class="mt-1">Test Results</span>
      </b-link>

      <b-link
        class="dashlink"
        active-class="active"
        :to="{ name: 'scheduler' }"
      >
          <b-icon-clock
          class="mr-3 mt-1"
          font-scale="1.5"
        ></b-icon-clock>
        <span class="mt-1">Schedule Tests</span>
      </b-link>

      <b-link
        class="dashlink"
        active-class="active"
        :to="{ name: 'studyroom' }"
      >
        <!-- <img src="@/assets/profile.png" class="mr-3 icon-img"> -->
        <b-icon-book
          class="mr-3 mt-1"
          font-scale="1.5"
        ></b-icon-book>
        <span class="mt-1 d-flex"
          >
            <span class="w-100" style="width:90%;flex-wrap:nowrap;margin-top:2px">AI Study Room</span>
            <img src="@/assets/ai.png" style="height:30px;top:-20px" class="ml-2 icon-img">
          
          <!-- <b-badge v-if="showBadge" variant="primary" class="new-badge">New</b-badge> -->
        </span>
        
        
      </b-link>

      <b-link
        class="dashlink"
        active-class="active"
        :to="{ name: 'leaderboard' }"
      >
        <b-icon-trophy
          class="mr-3 mt-1"
          font-scale="1.5"
        ></b-icon-trophy>
        <span class="mt-1">Leaderboard 
          <!-- <b-badge v-if="showBadge" variant="primary" class="new-badge">New</b-badge> -->
        </span>
      </b-link>

      <b-link
        class="dashlink"
        active-class="active"
        :to="{ name: 'performancecurve' }"
      >
        <!-- <img src="@/assets/schedule.png" class="mr-3 icon-img"> -->
        <b-icon-bar-chart-line
          class="mr-3 mt-1"
          font-scale="1.5"
        ></b-icon-bar-chart-line>
        <span class="mt-1">Your Metrics</span>
      </b-link>

      <b-link
        class="dashlink"
        :class="activeRoute2"
        active-class="active"
        :to="{ name: 'testspaces', query: { type : 'test'} }"
      >
        <!-- <img src="@/assets/profile.png" class="mr-3 icon-img"> -->
        <b-icon-geo
          class="mr-3 mt-1"
          font-scale="1.5"
        ></b-icon-geo>
        <span class="mt-1"
          >Testspaces
          <!-- <b-badge :variant="badgeVariant"
            >{{ orgspaces.count }}
          </b-badge> -->
          </span
        >
      </b-link>

      <b-link
        class="dashlink"
        :class="activeRoute4"
        active-class="active"
        :to="{ name: 'competitions', query: { type : 'competition'} }"
      >
        <!-- <img src="@/assets/profile.png" class="mr-3 icon-img"> -->
        <b-icon-trophy
          class="mr-3 mt-1"
          font-scale="1.5"
        ></b-icon-trophy>
        <span class="mt-1"
          >Competitions
          <!-- <b-badge v-if="showBadge" variant="primary" class="new-badge">New</b-badge> -->
        </span>
          <!-- <b-badge :variant="badgeVariant"
            >{{ orgspaces.count }}
          </b-badge></span
        > -->
      </b-link>


      <b-link
        class="dashlink"
        :class="activeRoute3"
        active-class="active"
        :to="{ name: 'referrals' }"
      >
        <b-icon-wallet
          class="mr-3 mt-1"
          font-scale="1.5"
        ></b-icon-wallet>
        <span class="mt-1"
          >Referrals
          <!-- <b-badge :variant="badgeVariant"
            >{{ referrals ? referrals.length : 0 }}
          </b-badge> -->
        </span>
      </b-link>

      <b-link
        class="dashlink"
        active-class="active"
        :to="{ name: 'subscription' }"
      >
        <b-icon-credit-card-fill
          class="mr-3 mt-1"
          font-scale="1.5"
        ></b-icon-credit-card-fill>
        <span class="mt-1">Subscription Plan</span>
      </b-link>

      <b-link
        class="dashlink"
        active-class="active"
        v-if="details.ambassador_status == 'ambassador'"
        :to="{ name: 'ambstats' }"
      >
        <!-- <img src="@/assets/profile.png" class="mr-3 icon-img"> -->
        <b-icon-award class="mr-3" font-scale="1.5"></b-icon-award>
        <span class="mt-1">Ambassador Stats</span>
      </b-link>

      <b-link
        class="dashlink"
        active-class="active"
        v-if="details.ambassador_status == 'ambassador'"
        :to="{ name: 'ambearnings' }"
      >
        <!-- <img src="@/assets/profile.png" class="mr-3 icon-img"> -->
        <b-icon-wallet class="mr-3" font-scale="1.5"></b-icon-wallet>
        <span class="mt-1">Earnings</span>
      </b-link>

      <b-link
        class="dashlink"
        active-class="active"
        :to="{ name: 'updateprofile' }"
      >
          <b-icon-person
          class="mr-3 mt-1"
          font-scale="1.5"
        ></b-icon-person>
        <span class="mt-1">Update Profile</span>
      </b-link>

      <b-link class="dashlink" active-class="active" @click="confirmLogout()">
        <b-icon-box-arrow-right
          class="mr-3 mt-1"
          font-scale="1.5"
        ></b-icon-box-arrow-right
>
        <span class="mt-1">Logout</span>
      </b-link>

      <div class="prompt-upgrade" v-if="details.plan == 'Free'">
        <img src="@/assets/saly.png" class="prompt-icon" />
        <div class="prompt-card text-center">
          <p class="prompt-text">
            Get access to detailed solutions, video explanations and many more
          </p>
          <b-button
            class="prompt-button p-2"
            :to="{ name: 'upgrade' }"
            variant="success"
            >Upgrade Now</b-button
          >
        </div>
      </div>

      <!-- <b-button class="log-out p-3 pl-3 w-75 mt-5 text-left"  variant="light"><img src="" class="mr-2 log-out-icon"> Logout </b-button> -->

      <!-- 
            <a href="https://quicktestng.com/pricing" v-if="plan == 'Free'" class="premup p-1 mb-2">Upgrade to Premium</a>
            <a class="premup p-2 w-75 text-center" @click="logout">Log Out
                <b-icon-box-arrow-in-right font-scale="1"></b-icon-box-arrow-in-right></a> -->
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";

export default {
  props: ["navbody"],
  // watch : {
  //     $route(){
  //         this.activeRoute
  //     }
  // },
  data() {
    return {
      currentbase: "",
      targetMonth: 4, // April
      targetYear: 2025,
    };
  },
  watch: {
    $route() {
      this.activeRoute;
    }
  },
  methods: {
    ...mapActions(["logOut"]),
    confirmLogout() {
      this.$bvModal.show("modal-logout");
    },
    loggingOut() {
      let now = new Date();
      now.setFullYear(now.getFullYear() - 20);
      document.cookie = `remember=;expires=${now.toUTCString()}`;
      document.cookie = `qid=;expires=${now.toUTCString()}`;
      this.logOut().then(() => {
        this.$router.push({
          name: "login"
        });
      });
    },
    hide2nd() {
      this.$bvModal.hide("modal-logout");
    }
  },
  computed: {
    ...mapState({
      details: state => state.loginmaster.details,
      orgspaces: state => state.dashboard.allorgspaces,
      referrals: state => state.dashboard.referrals
    }),
    showBadge() {
      const currentDate = new Date();
      const currentMonth = currentDate.getMonth() + 1; // getMonth() is 0-indexed
      const currentYear = currentDate.getFullYear();

      // Compare the current month and year with the target month and year
      if (currentYear < this.targetYear) {
        return true;
      } else if (currentYear === this.targetYear && currentMonth <= this.targetMonth) {
        return true;
      }
      return false;
    },
    showBadge2() {
      const currentDate = new Date();
      const currentMonth = currentDate.getMonth() + 1; // getMonth() is 0-indexed
      const currentYear = currentDate.getFullYear();

      // Compare the current month and year with the target month and year
      if (currentYear < this.targetYear) {
        return true;
      } else if (currentYear === this.targetYear && currentMonth <= this.targetMonth) {
        return true;
      }
      return false;
    },
    activeRoute() {
      let matchArray = this.$route.matched.findIndex(x => x.name == "results");
      // this.currentbase = 'results'
      //console.log(matchArray)
      return matchArray != -1 ? "active" : "inactive";
    },
    activeRoute2() {
      let matchArray = this.$route.matched.findIndex(x => x.name == "testspaces");
      //console.log(matchArray)
      // this.currentbase = 'spaces'
      return matchArray != -1 ? "active" : "inactive";
    },
    activeRoute4() {
      let matchArray = this.$route.matched.findIndex(x => x.name == "competitions");
      //console.log(matchArray)
      // this.currentbase = 'spaces'
      return matchArray != -1 ? "active" : "inactive";
    },
    activeRoute3() {
      let matchArray = this.$route.matched.findIndex(x => x.name == "referrals");
      //console.log(matchArray)
      // this.currentbase = 'spaces'
      return matchArray != -1 ? "active" : "inactive";
    },

    activeDashRoute() {
      let matchArray = this.$route.matched.findIndex(x => x.name == "dashhome");
      //console.log(matchArray)
      return matchArray != -1 ? "active" : "inactive";
    },
    badgeVariant() {
      let matchArray = this.$route.matched.findIndex(x => x.name == "spaces");
      //console.log(matchArray)
      return matchArray != -1 ? "light" : "dark";
    }
  }
};
</script>

<style scoped>
.dashlink {
  display: flex;
  font-size: 1.2rem;
  margin-top: 0.2rem;
  text-decoration: none;
  color: black;
  padding: 0.8rem;
  border-radius: 10px 10px;
}

.freetext {
  width: 100%;
  margin-bottom: -20px;
}

.active {
  background-color: #00984a;
  color: white;
}

.dbl {
  color: black;
}

.prelock {
  display: inline-block;
  margin-right: -20%;
}

.adiv {
  margin-top: 10px;
  height: 20vh;
}

.ldiv {
  height: 60vh;
}

.predisa {
  color: gray;
}

.dash-logo {
  width: 80%;
}
.icon-img {
  width: 37px;
}
.prompt-card {
  width: 100%;
  height: 250px;
  background-color: #f8f8f8;
  border-radius: 5px 5px;
}
.prompt-icon {
  position: relative;
  top: 100px;
  left: 20px;
}
.prompt-text {
  position: relative;
  top: 39%;
  left: 10%;
  width: 85%;
  font-size: 1rem;
}
.prompt-button {
  position: relative;
  top: 37%;
  font-size: 0.85rem;
  font-weight: bold;
}

.new-badge{
  position: relative;
  height:25px;
  top: 15px;
  padding-top:5px;
  right: -45px
}
@media (max-width: 999px) {
  .navbody {
    display: none;
  }
  .dash-logo {
    width: 50%;
  }
  .dashlink {
    font-size: 0.9rem;
    padding: 0.5rem;
  }
  .icon-img {
    width: 27px;
  }
}
</style>
